import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.15065V17.8865C1 18.9809 1.23021 19.1902 2.35126 19.1902H17.6555C18.7666 19.1902 19.0068 18.9903 19.0068 17.8856V6.15065C19.0068 5.0817 18.7946 4.84698 17.6555 4.84698H2.35126C1.23422 4.84604 1 5.03268 1 6.14971V6.15065ZM16.8858 16.1473H3.12998C4.63339 14.0302 7.30588 10.5009 7.98651 10.5009C8.64412 10.5009 10.8762 13.3524 11.8841 14.3563C11.8841 14.3563 13.1813 12.6831 13.861 12.6831C14.5536 12.6831 16.8638 16.1304 16.8858 16.1473ZM12.844 8.75799C12.844 7.87191 13.5867 7.15456 14.5046 7.15456C15.4224 7.15456 16.1661 7.87097 16.1661 8.75799C16.1661 9.64407 15.4224 10.3614 14.5046 10.3614C13.5867 10.3614 12.843 9.64501 12.843 8.75893L12.844 8.75799ZM9.44487 4.05988L6.81242 3.57725C5.9376 3.417 5.59128 3.47356 5.37808 4.05988H9.44487ZM21.8484 6.33164L19.7865 5.95458C19.7885 6.00266 19.7885 6.05073 19.7885 6.09881V17.9007C19.7885 18.4483 19.7515 19.0686 19.3031 19.4937C18.8666 19.9056 18.2351 19.9405 17.6765 19.9405H16.4344L19.0788 20.425C20.1699 20.6249 20.4441 20.4722 20.6573 19.3872L22.9234 7.85683C23.1296 6.80579 22.9665 6.53713 21.8484 6.33258V6.33164Z"
      fill="currentColor"
    />
  </svg>
);
